namespace advisorop.components.widgets {
    
    export class GaugeRiskBasesController{
        riskValue;
        riskMinEquity;
        riskMaxEquity;
        rtgName;
        rtgExt;
        dateDesc;
        rtqType;
        toleranceType;
        gauge;
        caption1;
        caption2;
        caption3;
        caption4;

        getSegmentColors(): any {

            var colors = [
                {
                    "code":"0000cc",
                    "minValue": "0",
                    "maxValue": Math.round(this.riskMinEquity*10)/10,
                },
                {
                    "code": "3399ff",
                    "minValue": Math.round(this.riskMinEquity * 10) / 10,
                    "maxValue": Math.round(this.riskMaxEquity * 10) / 10,
                }, {
                    "code": "0000cc",
                    "minValue": Math.round(this.riskMaxEquity * 10) / 10,
                    "maxValue": "100",
                }];

            return colors;      
        }

        updateGauge() {
            this.gauge = {
                "chart": {
                    "theme": "fint",
                    "baseFontSize":"14",
                    //"caption": "Portfolio Equity Allocation",
                    //"subcaption": "RTG: " + this.rtgName,
                    "lowerLimit": "0",
                    "upperLimit": "100",
                    "showValue": "1",
                    "numberSuffix": "%",
                    "gaugeFillMix": "{light-10},{light-70},{dark-10}",
                    "gaugeFillRatio": "40,20,40",
                    "showTickMarks": "0",
                    "showTickValues": "0",
                    "gaugeInnerRadius": "35",
                    "gaugeOuterRadius": "120",
                    "valueAbovePointer": "1",
                    "valueFontSize": "12",
                    "valueFontBold": "1",
                    "valueBgColor": "cccccc",
                    "valueBorderColor": "999999",
                    "valueAlpha": "80",
                    "valueBorderThickness": "2",
                    "valueBorderRadius": "2",
                    "valueBorderDashed": "1",
                    "valueBorderDashGap": "2",
                    "valueBorderDashLen": "5",
                },
                "colorRange": {
                    "color": this.getSegmentColors()
                },
                "dials": {
                    "dial": [
                        //{
                        //    "value": this.riskMinEquity,
                        //    "color": "000000"
                        //},
                        //{
                        //    "value": this.riskMaxEquity,
                        //    "color": "000000"
                        //},
                        {
                            "value": Math.round(this.riskValue*10)/10,
                            "color": "ffff00",
                            "showValue": "1",
                            "tooltext": "Current Equity Allocation: $value%",
                            //"rearExtension": "15"
                        },
                    ]
                },
                "trendPoints": {
                    "point": [
                        //Adding Trendpoint
                        {
                            "startValue": Math.round(this.riskMinEquity*10)/10,
                            "thickness": "2",
                            "color": "000000",
                            "usemarker": "1",
                        }, {
                            "startValue": Math.round(this.riskMaxEquity*10)/10,
                            "thickness": "2",
                            "color": "000000",
                            "usemarker": "1",
                        }
                    ]
                }
            };
            this.caption1 = "Core Portfolio is " + Math.round(this.riskValue * 10) / 10 + "% Equities";
            this.caption2 = "Potential Equity Allocation:"
            this.caption3 = "Min: " + Math.round(this.riskMinEquity*10)/10 + "%";
            this.caption4 = "Max: " + Math.round(this.riskMaxEquity*10)/10 + "%";
        };
        
        constructor(private advisorService: services.AdvisorService) {
                                
        }

        $onChanges(evt) {
            var updateGauge = false;
            for (var key in evt) {
                if (key === "riskValue" && this.riskValue >= 0) {
                    //console.log("Updating gauge to:" + this.riskValue);
                    updateGauge = true;
                }
                if (key == "riskMaxEquity" && this.riskMaxEquity >= 0) {
                    updateGauge = true;
                }
                if (key == "riskMinEquity" && this.riskMinEquity >= 0) {
                    updateGauge = true;
                }
                if (key === "rtgExt" && this.rtgExt) {
                    this.rtqType = this.rtgExt.rtq.rtqTypeDescription;
                    this.toleranceType = this.rtgExt.rtq.riskTolerance.name;
                    this.dateDesc = this.rtgExt.rtq.questionnaireResult.dateStart;
                }
            }
            if (updateGauge) {
                this.updateGauge();
            }
        }

        $onInit(): void { 
            if (this.riskValue == undefined) {
                this.riskValue = 0;
                this.riskMaxEquity = 0;
                this.riskMinEquity = 0;
            }
            this.updateGauge();            
        }

        $routerOnActivate(next, previous) {
            
        }        

    }



    class GaugeRiskBases implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        
        constructor() {
            this.bindings = {
                riskValue: "<",
                riskMinEquity: "<",
                riskMaxEquity: "<",
                rtgName: "<",
                rtgExt: "<"
            };
            this.controller = ["advisorService", GaugeRiskBasesController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/gauge-risk-bases.html';            
        }
    }
    angular.module(Constants.APP).component("gaugeRiskBases", new GaugeRiskBases());
    
}